// removed by extract-text-webpack-plugin
module.exports = {"tabs":"tabs__1n7Vv","secondary":"secondary__3WhTs","tab":"tab__3Gnm_","tab_active":"tab_active__2RYgO"};


//////////////////
// WEBPACK FOOTER
// ./components/tabs/style.scss
// module id = r1QN
// module chunks = 1 6